(function () {
  function initCardImgSlider(slider) {
    if (slider.__cwbCardImgInit) return;
    slider.__cwbCardImgInit = true;

    var track = slider.querySelector("[data-card-img-track]");
    var prev = slider.querySelector("[data-card-img-prev]");
    var next = slider.querySelector("[data-card-img-next]");
    var dotsWrap = slider.querySelector("[data-card-img-dots]");
    if (!track || !prev || !next) return;

    var slides = track.querySelectorAll(".show-card__img-slide");
    if (slides.length <= 1) return;

    prev.hidden = false;
    next.hidden = false;
    slider.classList.add("show-card__img-slider--multi");

    var index = 0;

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.querySelectorAll(".show-card__img-dot");
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    }

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
      prev.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      updateDots();
    }

    prev.addEventListener("click", function (e) {
      e.stopPropagation();
      goTo(index - 1);
    });
    next.addEventListener("click", function (e) {
      e.stopPropagation();
      goTo(index + 1);
    });

    track.addEventListener(
      "scroll",
      function () {
        var closest = index;
        var minDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(track.scrollLeft - slide.offsetLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = i;
          }
        });
        if (closest !== index) {
          index = closest;
          prev.disabled = index === 0;
          next.disabled = index === slides.length - 1;
          updateDots();
        }
      },
      { passive: true }
    );

    prev.disabled = true;
    next.disabled = slides.length <= 1;
    updateDots();

    slider.__cwbCardImgDestroy = function () {
      delete slider.__cwbCardImgInit;
      delete slider.__cwbCardImgDestroy;
    };
  }

  function initDesignsSlider(wrap) {
    if (wrap.__cwbDesignsInit) return;
    wrap.__cwbDesignsInit = true;

    var track = wrap.querySelector("[data-designs-track]");
    var prev = wrap.querySelector("[data-designs-prev]");
    var next = wrap.querySelector("[data-designs-next]");
    if (!track || !prev || !next) return;

    wrap.querySelectorAll("[data-card-img-slider]").forEach(initCardImgSlider);

    function getStep() {
      var card = track.querySelector(".show-card");
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 22;
      return card.offsetWidth + gap;
    }

    function updateNav() {
      var scrollable = track.scrollWidth > track.clientWidth + 2;
      var max = track.scrollWidth - track.clientWidth - 2;
      wrap.classList.toggle("designs-slider--scrollable", scrollable);
      prev.disabled = !scrollable || track.scrollLeft <= 2;
      next.disabled = !scrollable || track.scrollLeft >= max;
    }

    function scrollBy(direction) {
      track.scrollBy({ left: direction * getStep(), behavior: "smooth" });
    }

    prev.addEventListener("click", function () {
      scrollBy(-1);
    });
    next.addEventListener("click", function () {
      scrollBy(1);
    });
    track.addEventListener("scroll", updateNav, { passive: true });
    window.addEventListener("resize", updateNav);
    updateNav();

    wrap.__cwbDesignsDestroy = function () {
      window.removeEventListener("resize", updateNav);
      wrap.querySelectorAll("[data-card-img-slider]").forEach(function (slider) {
        if (slider.__cwbCardImgDestroy) slider.__cwbCardImgDestroy();
      });
      delete wrap.__cwbDesignsInit;
      delete wrap.__cwbDesignsDestroy;
    };
  }

  function scrollToBlock(block) {
    var wrap = block.closest("[data-designs-slider]");
    var track = wrap && wrap.querySelector("[data-designs-track]");
    if (!track) return;
    var left = block.offsetLeft - track.offsetLeft;
    track.scrollTo({ left: left, behavior: "smooth" });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-designs-slider]").forEach(initDesignsSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });

  document.addEventListener("shopify:section:unload", function (e) {
    e.target.querySelectorAll("[data-designs-slider]").forEach(function (wrap) {
      if (wrap.__cwbDesignsDestroy) wrap.__cwbDesignsDestroy();
    });
  });

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:block:select", function (e) {
      var block = e.target.closest(".show-card");
      if (block) scrollToBlock(block);
    });
  }
})();
